<h1 mat-dialog-title>Inschrijven voor {{ event.name }}</h1>
<div mat-dialog-content>
  <mat-list>
    @if (!withoutQuestions && event.calendarEventQuestions?.length > 0) {
      <mat-list-item>
        <mat-icon mat-list-icon>quiz</mat-icon>
        <div mat-line>Vragen bij dit evenement</div>
      </mat-list-item>
      @for (control of questionsForm.controls; track control; let i = $index) {
        <mat-list-item
          >
          @if (
            event.calendarEventQuestions[i].questionType.normalizedName ===
            'checkbox'
            ) {
            <div
              mat-line
              >
              <mat-checkbox
                [formControl]="questionsForm.controls[i]"
                [name]="'question-' + i"
                color="primary"
                labelPosition="before"
                >
                {{ event.calendarEventQuestions[i].questionText }}
              </mat-checkbox>
            </div>
          }
          @if (
            event.calendarEventQuestions[i].questionType.normalizedName ===
            'nummer'
            ) {
            <div
              mat-line
              >
              <div>{{ event.calendarEventQuestions[i].questionText }}</div>
              <mat-form-field>
                <input
                  matInput
                  type="number"
                  placeholder="Hoeveel?..."
                  [name]="'question-' + i"
                  [formControl]="questionsForm.controls[i]"
                  />
                </mat-form-field>
              </div>
            }
            @if (
              event.calendarEventQuestions[i].questionType.normalizedName === 'zin'
              ) {
              <div
                mat-line
                >
                {{ event.calendarEventQuestions[i].questionText }}
              </div>
            }
            @if (
              event.calendarEventQuestions[i].questionType.normalizedName === 'zin'
              ) {
              <div
                mat-line
                >
                <mat-form-field>
                  <input
                    matInput
                    [name]="'question-' + i"
                    placeholder="Vul je antwoord in..."
                    [formControl]="questionsForm.controls[i]"
                    />
                  </mat-form-field>
                </div>
              }
            </mat-list-item>
          }
        }
        @if (!onlyQuestions && event.allowMultipleTickets) {
          <mat-list-item>
            <mat-icon mat-list-icon>quiz</mat-icon>
            <div mat-line>Hoeveel tickets wil je?</div>
            <div mat-line class="list-item-form">
              <mat-radio-group [formControl]="numberOfTicketsForm">
                @for (i of rangeTickets; track i) {
                  <mat-radio-button [value]="i">{{
                    i
                  }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>
          </mat-list-item>
        }
        @if (event.paymentNeeded && !onlyQuestions) {
          <mat-list-item>
            <mat-icon mat-list-icon>quiz</mat-icon>
            <div mat-line>Selecteer een betalingsmethode</div>
            <div mat-line class="list-item-form">
              <mat-radio-group [formControl]="paymentMethod">
                @if (event.canPayWithIdeal) {
                  <mat-radio-button value="iDeal"
                    >IDeal</mat-radio-button
                    >
                }
                @if (event.canPayWithSignRequest) {
                  <mat-radio-button
                    value="signRequest"
                    >SignRequest</mat-radio-button
                    >
                  }
                  @if (event.canPayOnOrca) {
                    <mat-radio-button value="orca"
                      >Op Orca met Orkaart</mat-radio-button
                      >
                    }
                    @if (aleadyPayed) {
                      <mat-radio-button value="alBetaald"
                        >Persoon heeft al Betaald</mat-radio-button
                        >
                      }
                    </mat-radio-group>
                  </div>
                </mat-list-item>
              }
              @if (
                !onlyQuestions &&
                event.paymentNeeded &&
                paymentMethod.value === 'signRequest'
                ) {
                Na het inschrijven ontvang je in je mail een SignRequest. Dit is de
                machtiging waarmee je orca machtigt om de kosten van dit evenement van je
                rekening af te schrijven. Een getekende machtiging word gezien als een
                voltooide betaling.
              }
            </mat-list>
          </div>

          <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Annuleren</button>
            <button
              mat-button
              (click)="submit()"
              color="primary"
              cdkFocusInitial
              [disabled]="questionsForm.invalid && !withoutQuestions"
              >
              Akkoord
            </button>
          </mat-dialog-actions>
